export default {"src":"/_next/static/media/holdMoney_64.222088ff.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};